import { Box, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LocalStorageToken } from '../../interactors/services/AuthService'
import { PATHS } from '../PATHS'

/**
 * Receives a session from the new interface so a member who needs the previous one can get there
 * without signing in again.
 *
 * The token travels in the URL fragment: a fragment is never sent to a server, so it stays out of
 * access logs and out of any proxy in between. It is read once, stored, and removed from the
 * address bar straight away so it does not linger in the browser history.
 */
export const HandoffPage: React.FC = () => {
  const navigate = useNavigate()
  const [failed, setFailed] = useState<boolean>(false)

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token')

    // Drop the fragment before anything else, so a reload or a back navigation cannot replay it.
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)

    if (!token) {
      setFailed(true)

      return
    }

    LocalStorageToken.setToken(token)
    // Replace rather than push: the handoff must not sit in the history stack.
    window.location.replace(PATHS.animals.absolute)
  }, [navigate])

  if (failed) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 12, px: 3 }}>
        <Typography variant="h6" textAlign="center">
          Ce lien de connexion n’est plus valide.
        </Typography>
        <Typography textAlign="center" sx={{ maxWidth: 420 }}>
          Connectez-vous pour accéder à l’ancienne interface, ou retournez sur{' '}
          <a href="https://asso.petso.fr">asso.petso.fr</a>.
        </Typography>
        <a href={PATHS.login.absolute}>Me connecter</a>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 12 }}>
      <CircularProgress />
      <Typography>Ouverture de l’ancienne interface…</Typography>
    </Box>
  )
}
